import React from "react";
import Casestudybanner from "./Casestudybanner";
import Whatis from "./Whatis";
import WhyWe from "./WhyWe";
import Challenges from "./Challenges";
import Impact from "./Impact";
import Achievements from "./Achievements";
import Takeaways from "./Takeaways";
import Conclusion from "./Conclusion";


export default function CaseStudyPage() {
    return (
        <>
           <Casestudybanner/>
           <Whatis/>
           <WhyWe/>
           <Challenges/>
           <Impact/>
           <Achievements/>
           <Takeaways/>
           <Conclusion/>
            
        </>
    );
}